import * as angular from 'angular';
import { MetricsService } from 'modules/metrics/MetricsService';
import { StatisticsService2 } from './StatisticsService2';
export default angular
    .module('statistics', [])
    .service('StatisticsService2', StatisticsService2)
    .service('MetricsService', MetricsService)
    .name;
